export default "/images/logo.svg?af622b91646ba802d260650bb49a56af";